import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { UserDetails } from 'src/app/interfaces/UserDetails';
import { DataService } from 'src/app/services/data.service';
import { PlatformService } from 'src/app/services/platform.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss'],
})
export class RulesComponent implements OnInit {
  isAdmin = false;
  user$: Observable<UserDetails>;

  constructor(
    private title: Title,
    private data: DataService,
    private platform: PlatformService,
    private user: UserService
  ) {
    this.title.setTitle('Rules - WhereTaken');
    this.user$ = this.user.getUserDetails();
  }

  ngOnInit(): void {
    if (!this.platform.isInBrowser()) return;
    const admin = localStorage.getItem('admin');
    this.isAdmin = admin === 'true' ? true : false;
  }

  navigateBack() {
    this.data.navigateToPreviousPage();
  }

  manageConsent() {
    window.adconsent && window.adconsent('showGUI');
  }
}
